"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _vue = _interopRequireDefault(require("vue"));
var _buefy = _interopRequireDefault(require("buefy"));
var _vuelidate = _interopRequireDefault(require("vuelidate"));
var _vuelayers = _interopRequireDefault(require("vuelayers"));
var _vueQrcodeComponent = _interopRequireDefault(require("vue-qrcode-component"));
var _vueFullscreen = _interopRequireDefault(require("vue-fullscreen"));
var _vueTelInput = _interopRequireDefault(require("vue-tel-input"));
require("vuelayers/lib/style.css");
var GmapVue = _interopRequireWildcard(require("gmap-vue"));
var _vueTheMask = _interopRequireDefault(require("vue-the-mask"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_vue.default.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries: 'places,drawing,visualization'
  },
  installComponents: true
});
_vue.default.config.productionTip = false;
_vue.default.use(_vuelayers.default, {
  dataProjection: 'EPSG:4326'
});
_vue.default.use(_vuelidate.default);
_vue.default.use(_buefy.default, {
  defaultDayNames: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  defaultMonthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
  defaultFirstDayOfWeek: 0,
  defaultDateFormatter: function defaultDateFormatter(date) {
    return date.toLocaleDateString('pt-BR');
  }
});
_vue.default.use(_vueTelInput.default);
_vue.default.use(_vueFullscreen.default);
_vue.default.use(_vueTheMask.default);
_vue.default.component('qr-code', _vueQrcodeComponent.default);